import * as React from 'react';
import { SelectManager, VirtualChildComponent, VirtualChildData } from '@easytwin/runtime';
import { AdditionalLayersOutlined, InstanceOutlined } from '@easyv/react-icons';
import { Divider } from '@arco-design/web-react';
import { observer } from 'mobx-react-lite';
import { CollapseBox, ProButton } from '@/UIGenerator';
import { ComponentBasePanel } from './ComponentBasePanel';
import { HintTooltip } from './HintTooltip';
import CustomAttributeValueForm from './CustomAttributeValueForm';

export interface VirtualChildDataPanelProps {
  title: string;
  comp: VirtualChildComponent;
  compJson: VirtualChildData<any>;
  /**
   *  VirtualChildData类型 { id: string, name: string, customAttribute: Record<string,any>, config: { points: IVector3[] } } 请使用 <VirtualChildDataPoints/>
   * VirtualChildData类型  { id: string, name: string, customAttribute: Record<string,any>, config: { position: IVector3 } } 请使用 <VirtualChildDataPosition/>
   */
  children: React.ReactNode;
  editorChildrenDataPanel?: React.ReactNode;
  nodeAfter?: React.ReactNode;
  titleExtra?: React.ReactNode;
}

/**
 * 数字要素子要素专用ui
 */
export const VirtualChildDataPanel: React.FC<VirtualChildDataPanelProps> = observer((props) => {
  const { title, comp, compJson, children, nodeAfter, editorChildrenDataPanel, titleExtra } = props;

  return (
    <ComponentBasePanel comp={comp} titleExtra={titleExtra}>
      <div className='my-4 flex items-center mx-3'>
        {comp.attachComponent?.isEditing ? (
          <ProButton
            long
            size='small'
            type='primary'
            onClick={() => {
              comp.attachComponent?.endEdit();
            }}
          >
            结束新增
          </ProButton>
        ) : (
          <ProButton
            long
            size='small'
            onClick={() => {
              comp.attachComponent?.startEdit();
            }}
          >
            新增子要素
          </ProButton>
        )}
      </div>
      {editorChildrenDataPanel}
      <Divider className='!my-0' />
      <div className='mx-3 flex items-center h-12'>
        <HintTooltip content='选择母版'>
          <div
            className='h-7 flex-1 flex items-center justify-between hover:bg-FFFFFF0A cursor-pointer rounded'
            onClick={() => {
              comp.scene.getManager(SelectManager)?.select([comp.attachComponent!], false);
            }}
          >
            <div className='flex items-center text-white gap-x-1'>
              <AdditionalLayersOutlined size={14} style={{ paddingLeft: 5 }} />
              <span>{comp.attachComponent?.name}</span>
            </div>
            <div className='w-6 h-6 flex items-center justify-center'>
              <InstanceOutlined size={14} />
            </div>
          </div>
        </HintTooltip>
      </div>
      <Divider className='!my-0' />
      <CollapseBox
        noStyle
        disable
        showDivider
        title='数据'
        headerClassName='px-0'
        type='area'
        showConnectionLine={false}
      >
        {children}
        <CustomAttributeValueForm comp={comp} attribute={compJson.customAttribute} />
      </CollapseBox>
      {nodeAfter}
    </ComponentBasePanel>
  );
});
